export default {
  apiKey: "AIzaSyBHJ43JeMYUgD7oi_FGK0CKXVoQyxDR9T8",
  authDomain: "data-analysis-tech-privacy.firebaseapp.com",
  databaseURL: "https://data-analysis-tech-privacy.firebaseio.com",
  projectId: "data-analysis-tech-privacy",
  storageBucket: "data-analysis-tech-privacy.appspot.com",
  messagingSenderId: "595762466525",
  appId: "1:595762466525:web:75a72dd3eb8014b1ae5534",
  measurementId: "G-J3BMFY52DS"
};
